
/* eslint-disable */
import Vue from 'vue'
import {Component, Watch, Provide} from 'vue-property-decorator'
import music from '@/views/search/searchMusic.vue'
import artists from '@/views/search/searchArtist.vue'
import albums from '@/views/search/searchAlbum.vue'
import { AlbumModel, ArtistModel, ArtistTrackModel } from '@/models'

@Component({
    components: {
        music,
        artists,
        albums
    }
})
export default class Search extends Vue {
    @Provide() tabView = 'all'
    @Provide() loader = true
    audiusTracks: ArtistTrackModel[] = []
    audiusArtists: any[] = []
    sunoTracks: ArtistTrackModel[] = []
    sunoArtists: any[] = []
    searchToken = 0

    slicedStuffs (obj: ArtistModel[] | AlbumModel[] | ArtistTrackModel[], num: number) {
        return obj.slice(0,num)
    }

    runSearch(query: string) {
        const normalizedQuery = (query || '').trim()
        this.loader = true
        const token = ++this.searchToken
        this.audiusTracks = []
        this.audiusArtists = []
        this.sunoTracks = []
        this.sunoArtists = []

        if (normalizedQuery.length < 2) {
            this.loader = false
            return Promise.resolve([])
        }

        const tasks: Array<Promise<any>> = [
            // Jamendo search
            this.$store.dispatch('trackModule/fetchSearchedTracks', normalizedQuery),
            this.$store.dispatch('artistModule/fetchSearchedArtists', normalizedQuery),
            this.$store.dispatch('albumModule/fetchSearchrdAlbums', normalizedQuery),
            // Audius search
            this.$store.dispatch('audiusModule/searchTracks', normalizedQuery).then((tracks: ArtistTrackModel[]) => {
                if (token !== this.searchToken) {
                    return
                }
                this.audiusTracks = tracks || []
            }),
            this.$store.dispatch('audiusModule/searchUsers', normalizedQuery).then((users: any[]) => {
                if (token !== this.searchToken) {
                    return
                }
                this.audiusArtists = users || []
            }),
        ]

        if (normalizedQuery.length >= 3) {
            tasks.push(
                this.$store.dispatch('sunoModule/searchCatalog', normalizedQuery).then((result: { tracks: ArtistTrackModel[]; users: any[] }) => {
                    if (token !== this.searchToken) {
                        return
                    }
                    this.sunoTracks = result.tracks || []
                    this.sunoArtists = result.users && result.users.length ? result.users : this.buildArtistsFromTracks(this.sunoTracks)
                }).catch(() => {
                    if (token !== this.searchToken) {
                        return
                    }
                    this.sunoTracks = []
                    this.sunoArtists = []
                })
            )
        }

        return Promise.all(tasks).finally(() => {
            if (token === this.searchToken) {
                this.loader = false
            }
        })
    }

    buildArtistsFromTracks(tracks: ArtistTrackModel[]) {
        const seen = new Set<string>()
        const artists: any[] = []
        tracks.forEach((track) => {
            if (seen.has(track.artist_id)) {
                return
            }
            seen.add(track.artist_id)
            artists.push({
                id: track.artist_id,
                name: track.artist_name,
                image: track.image || '',
                joindate: track.releasedate || '',
                website: track.website || ''
            })
        })
        return artists
    }

    @Watch('$route.params.query')
    onPropertyChange(newValue: string) {
        this.runSearch(newValue)
    }

    get tracks () {
        const jamendo = this.$store.getters['trackModule/getTracks'] || []
        return [...jamendo, ...this.audiusTracks, ...this.sunoTracks]
    }
    get artists () {
        const jamendo = this.$store.getters['artistModule/getArtistsTotal'] || []
        return [...jamendo, ...this.audiusArtists, ...this.sunoArtists]
    }
    get albums () {
        return this.$store.getters['albumModule/getAlbums']
    }

    created () {
        this.runSearch(this.$route.params.query)
    }
}
